import { createFileRoute } from '@tanstack/react-router';
import { AdminDashboardPage } from '@/features/admin/admin-dashboard-page';

export const Route = createFileRoute('/gm/')({
  component: GmDashboardRoute,
});

function GmDashboardRoute() {
  return <AdminDashboardPage portalBase="/gm" />;
}
